import * as React from 'react';
import {CONTACT_ACTION, CONTACT_TAB, CONTACT_RELEVANT_DATE, roleOptions} from '../../../Config/appConfig';
import {Option} from '../../../Config/dataModel';
import Grid from '@material-ui/core/Grid';
import Select from 'react-select';
import { reactSelectStyles } from 'src/Components/constants';

const menuDefault = require('../../../resource/img/menu-default.svg');
const menuFocused = require('../../../resource/img/menu-focused.svg');

interface InvitationTableViewCellProps {
    currentTab: string,
    data: any,
    clickAction: (user: string, action: string, userId: string, role?: Option) => void
}

interface InvitationTableViewCellState {
    expand: boolean
}

class InvitationTableViewCell extends React.Component <InvitationTableViewCellProps, InvitationTableViewCellState> {
    public shouldExpand: boolean = false;
    public wrapperRef: HTMLDivElement;

    public constructor(props: InvitationTableViewCellProps) {
        super(props);
        this.state = {
            expand: false
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.clickExpand = this.clickExpand.bind(this);
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickExpand);
    }

    public setWrapperRef(node: HTMLDivElement) {
        this.wrapperRef = node;
    }

    public setExpand() {
        this.setState({
            expand: !this.state.expand
        });
    }

    public getActions(user: string, actions: string[], userId: string) {
        let list = [];
        for (let i = 0; i < actions.length; i++) {
            list.push(
                <button
                    key={i}
                    className="cmWhiteBtn cmText invitationTableViewCellActionOption"
                    onClick={(e) => this.clickAction(e, user, actions[i], userId)}>
                        {actions[i]}
                </button>
            );
        }
        return (<div className="invitationTableViewCellAction">{list}</div>);
    }

    public clickAction(event: React.MouseEvent<HTMLElement>, user: string, action: string, userId: string) {
        event.preventDefault();
        this.props.clickAction(user, action, userId);
        this.shouldExpand = false;
        this.setExpand();
    }

    public clickExpand(event: any) {
        event.preventDefault();
        if (this.state.expand) document.removeEventListener('mousedown', this.clickExpand);
        else document.addEventListener('mousedown', this.clickExpand);
        if ((event.type === 'click' || this.wrapperRef && !this.wrapperRef.contains(event.target)) && !this.shouldExpand) this.setExpand();
    }

    public render() {
        if (this.props.currentTab === CONTACT_TAB.COMPANY) {
            const isDisabled = this.props.data.lastActive.label === CONTACT_RELEVANT_DATE.DEACTIVATED.label;
            return (
                <div className="cmTableViewCell cmText">
                    <Grid className="cmTableViewCol" item xs={8}>
                        <div className={`cmTableViewCellData${isDisabled ? " disabled" : ""} invitationTableViewCellData${isDisabled ? " cmObliqueText" : ""}`}>{this.props.data.companyName}</div>
                    </Grid>
                    <Grid className="cmTableViewCol contactTableViewCol" item xs={3}>
                        <div className={`cmTableViewCellData${isDisabled ? " disabled" : ""} contactTableViewCellLabel`}>{this.props.data.lastActive.label}</div>
                        <div className={`cmTableViewCellData${isDisabled ? " disabled" : ""} invitationTableViewCellData${isDisabled ? " cmObliqueText" : ""}`}>{this.props.data.lastActiveDate}</div>
                    </Grid>
                    <Grid className="cmTableViewCol contactTableViewCol" item xs={1}>
                        <div ref={this.setWrapperRef}>
                            <button onClick={this.clickExpand}>
                                <img height="20" width="20" className="invitationTableViewCellActionIcon" src={this.state.expand ? menuFocused : menuDefault}/>
                            </button>
                            {this.state.expand && this.getActions(this.props.data.companyName, this.props.data.actions, this.props.data.userId)}
                        </div>
                    </Grid>
                </div>
            );
        }
        else {
            const isDisabled = this.props.data.lastActive.label === CONTACT_RELEVANT_DATE.DEACTIVATED.label;
            const isApiUserTab = this.props.currentTab === CONTACT_TAB.API_USER;

            return (
                <div className="cmTableViewCell cmText">
                    <Grid className="cmTableViewCol contactTableViewCol" item xs={4}>
                        <div className={`cmTableViewCellData${isDisabled ? " disabled" : ""} contactTableViewCellLabel`}>{this.props.data.email}</div>
                        <div className={`cmTableViewCellData${isDisabled ? " disabled" : ""} invitationTableViewCellData${isDisabled ? " cmObliqueText" : ""}`}>{this.props.data.username}</div>
                    </Grid>
                    <Grid className="cmTableViewCol contactTableViewCol" item xs={3}>
                        <div className={`cmTableViewCellData${isDisabled ? " disabled" : ""} contactTableViewCellLabel`}>{this.props.data.lastActive.label}</div>
                        <div className={`cmTableViewCellData${isDisabled ? " disabled" : ""} invitationTableViewCellData${isDisabled ? " cmObliqueText" : ""}`}>{this.props.data.lastActiveDate}</div>
                    </Grid>
                    <Grid className="cmTableViewCol invitationTableViewColRole" item xs={2}>
                        <Select
                            styles={reactSelectStyles}
                            className={isDisabled ? "react-select__container disabled cmObliqueText" : "react-select__container"}
                            classNamePrefix="react-select"
                            options={roleOptions}
                            value={this.props.data.role.value}
                            clearable={false}
                            onChange={(role) => this.props.clickAction(this.props.data.email, this.props.data.role.value === roleOptions[0] ? CONTACT_ACTION.CHANGE_ROLE.BE_ADMIN : CONTACT_ACTION.CHANGE_ROLE.BE_USER, this.props.data.userId, role)}
                            isDisabled={this.props.data.role.disabled || isApiUserTab}/>
                    </Grid>
                    <Grid className="cmTableViewCol" item xs={isApiUserTab ? 3 : 2}>
                        <div className={`cmTableViewCellData${isDisabled ? " disabled" : ""} invitationTableViewCellData${isDisabled ? " cmObliqueText" : ""}`}>{this.props.data.lastActive.status.label}</div>
                    </Grid>
                    {!isApiUserTab &&
                    <Grid className="cmTableViewCol contactTableViewCol" item xs={1}>
                        {this.props.data.actions.length ?
                            <div ref={this.setWrapperRef}>
                                <button onClick={this.clickExpand}>
                                    <img height="20" width="20" className="invitationTableViewCellActionIcon" src={this.state.expand ? menuFocused : menuDefault}/>
                                </button>
                                {this.state.expand && this.getActions(this.props.data.email, this.props.data.actions, this.props.data.userId)}
                            </div> : null}
                    </Grid>}
                </div>
            );
        }
    }
}

export default InvitationTableViewCell;



// WEBPACK FOOTER //
// ./src/Components/Contact/Invitation/InvitationTableViewCell.tsx